import {isEmpty} from 'lodash';
import React from 'react';
import styles from './modalChart.css';
import Empty from './empty.png';
const echarts = require('echarts');
let myChart = null; let option = null;
const toolbox = {
    show: true,
    right: 20,
    feature: {
        saveAsImage: {}
    },
    iconStyle: {
        borderColor: '#f28c2c'
    }
};
class ModalCharts extends React.Component {

    constructor (props) {
        super(props);
        this.state = {
            chartData: this.props.data, // 图表数据
            isError: false,
            isEmpty: false
        };
    }

    componentDidMount () {

    }
    componentWillReceiveProps (nextProps) {
        this.getChartsData({...nextProps});
    }

    // 图表数据处理
    getChartsData ({blockData, tableData}) {
        const {inputVariables, setDataGroup, setChartType, setAxisTitle: {xAxisTitle, yAxisTitle = ''}} = blockData;
        const chartsEle = document.getElementById('charts');
        const legendData = Array.from(new Set(Object.keys(inputVariables).concat(Object.keys(setDataGroup))));// 组
        const params = {...blockData, ...tableData, xAxisTitle, yAxisTitle, legendData};
        // echart存在时 先销毁
        myChart && myChart.dispose();
        // 数据项为空时 设置为空
        this.setState({
            isEmpty: legendData.length === 0
        }, () => {
            if (this.state.isEmpty) return;
            // echart 初始化
            myChart = echarts.init(chartsEle);
            // 获取option配置
            console.log(`handle${setChartType.replace(/\b(\w)(\w*)/g, ($0, $1, $2) => $1.toUpperCase() + $2.toLowerCase())}Charts`)
            option = this[`handle${setChartType.replace(/\b(\w)(\w*)/g, ($0, $1, $2) => $1.toUpperCase() + $2.toLowerCase())}Charts`](params);
            // 生成图表
            option && myChart.setOption(option);
        });
    }

    // 表格
    handleTableCharts (params) {
        // console.log(params)
    }

    // 折线图
    handleLineCharts (params) {
        const {thead, tbody, xAxisTitle, yAxisTitle, legendData} = params;
        return {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: legendData
            },
            toolbox,
            xAxis: {
                type: 'category',
                data: tbody.map(item => item[0]) || [],
                name: xAxisTitle
            },
            yAxis: {
                type: 'value',
                name: yAxisTitle,
                axisLine: {show: true}
            },
            series: legendData.map(item => {
                const idx = thead.indexOf(item);
                return {
                    name: item,
                    type: 'line',
                    data: tbody.map(ii => ii[idx])
                };
            })
        };
    }

    // 柱状图
    handleHistogramCharts (params) {
        const {tbody, xAxisTitle, yAxisTitle, legendData} = params;
        return {
            legend: {},
            tooltip: {},
            toolbox,
            dataset: {
                source: new Array(['product', ...legendData]).concat(tbody) // 数据源
            },
            xAxis: {type: 'category', name: xAxisTitle},
            yAxis: {
                name: yAxisTitle,
                axisLine: {show: true}
            },
            series: legendData.map(() => ({type: 'bar'})) // 类型
        };
    }

    // 双轴图
    handleBiaxialCharts (params) {
        const {legendData, setDataGroup, setRightYTitle, thead, tbody, xAxisTitle, yAxisTitle} = params;
        // Y轴的数据项
        const rightYNames = [];
        for (const group in setDataGroup) {
            if (setDataGroup[group].value == 'right_y') {
                rightYNames.push(setDataGroup[group].name);
            }
        }
        // series数据
        const series = legendData.map(item => {
            const idx = thead.indexOf(item);
            const isRightY = rightYNames.length > 0 && rightYNames.indexOf(item) > -1;
            const obj = {
                name: item,
                type: isRightY ? 'bar' : 'line',
                data: tbody.map(v => v[idx])
            };
            isRightY && (obj.yAxisIndex = 1);
            return obj;
        });
        return {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: legendData
            },
            toolbox,
            xAxis: [
                {
                    type: 'category',
                    data: tbody.map(item => item[0]) || [],
                    name: xAxisTitle,
                    axisPointer: {
                        type: 'shadow'
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    position: 'left',
                    name: yAxisTitle
                },
                {
                    type: 'value',
                    position: 'right',
                    name: setRightYTitle,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'EE6666'
                        }
                    }
                }
            ],
            series: series
        };
    }

    // 饼图
    handlePieCharts (params) {
        const {inputVariables, tbody} = params;
        const keysArr = Object.keys(inputVariables);
        const series = [];
        if (keysArr.length > 2) {
            this.setState({
                isError: true
            });
            return null;
        }
        for (const item in inputVariables) {
            if (inputVariables[item].xAxisName && inputVariables[item].xAxisName.length > 0) {
                const index = keysArr.indexOf(item);
                const {xAxisName, yAxisData} = inputVariables[item];
                series.push({
                    name: item,
                    type: 'pie',
                    radius: [12, 60],
                    center: index === 0 ? ['25%', '50%'] : ['75%', '50%'],
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 5
                    },
                    data: xAxisName.map(item => {
                        const idx = xAxisName.indexOf(item);
                        return {value: yAxisData[idx], name: item};
                    })
                });
            }
        }
        // 只有一条数据时 居中显示
        if (series.length == 1) {
            series[0].center = ['50%', '50%'];
            series[0].radius = [20, 100];
        }
        return {
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            toolbox,
            legend: {
                left: 'center',
                data: tbody.map(item => item[0]) || []
            },
            series: series
        };
    }


    render () {

        return (<div className={styles.chartBox}>
            <div
                id="charts"
                style={{width: this.props.isLarge ? 950 : 570, height: this.props.isLarge ? 470 : 370}}
            >
                {this.state.isError ? <div className={styles.errorTips}>饼图只支持不多于两组数据的展示</div> : null}
            </div>
            {this.state.isEmpty ? <div className={styles.noData}>
                <img
                    style={{width: 180, marginTop: 20}}
                    src={Empty}
                    alt="暂无数据"
                />
                <p style={{fontSize: '14px', lineHeight: 2, color: '#666'}}>暂无数据</p>
            </div> : null}
        </div>);
    }

}
export default ModalCharts;
